import Vue from 'vue';
import Main from './main.vue';

let ToastConstructor = Vue.extend(Main);

const Toast = function(options) {
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  let component = new ToastConstructor({
    data: options
  }).$mount();
  document.body.appendChild(component.$el);
};

export default Toast;

